import { render, staticRenderFns } from "./InquiryConfirmPop.vue?vue&type=template&id=a65e70f0&scoped=true&"
import script from "./InquiryConfirmPop.vue?vue&type=script&lang=js&"
export * from "./InquiryConfirmPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65e70f0",
  null
  
)

component.options.__file = "InquiryConfirmPop.vue"
export default component.exports